import { call, select, takeLeading } from 'redux-saga/effects'
import { REFRESH_CACHE } from '../actions/appState'
import networkConnected from '../utils/networkConnected'
import { bridge_updateCFDVersion } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { getOrder } from '../selectors/order'
import { STADIUM_ORDER_STATES } from '../utils/orderStates'
import { cancelOrderSaga } from './order'
import { callPeripheralBridge } from '../VNPeripheralBridge/Utils'
import { PERIPHERAL_BRIDGE_CALL_METHODS } from '../VNPeripheralBridge/Enums'
import { getSummitMode } from '../VNMode/Selectors'

export function* watchRefreshCacheSaga() {
  yield takeLeading(REFRESH_CACHE, refreshCacheSaga)
}

export function* refreshCacheSaga(params = {}) {
  const { shouldClearCart = false } = params
  try {
    yield call(networkConnected)

    if (shouldClearCart) {
      const currentOrderId = yield select((state) => state.order?.currentOrderId)
      const curOrder = yield select((state) => getOrder(state, currentOrderId))

      if (curOrder?.state === STADIUM_ORDER_STATES.SUBMITTED || curOrder?.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) {
        yield call(cancelOrderSaga, { payload: { uuid: currentOrderId, reason: 'User triggered Sync Network Data.' } })
      }
    }

    // need to tell the CFD to update its version, we really don't care if there isn't a CFD attached
    // since if there is nothing, the bridge just silently fails
    bridge_updateCFDVersion()

    // Summit mode, notify APK a "sync network data" event
    const isSummit = yield select(getSummitMode)
    if (isSummit) {
      callPeripheralBridge(PERIPHERAL_BRIDGE_CALL_METHODS.ON_SYNC_NETWORK_DATA)
    }
    window.location = `${window.location.origin}/?cacheBuster=${new Date().toISOString()}`
  } catch (e) {
    console.error('Error refreshing cache: check your network connectivity.')
  }
}
